import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext, useSearchParams } from 'react-router-dom';
import { Card } from "../../common_components/Layout";
import { TitleAndText } from "../components/TitleAndText";
import { PrimaryButton } from "../../common_components/Buttons";
import CreateMissionHeaderAndTitleRow from "../components/CreateMissionHeaderAndTitleRow";


import { useAlert } from 'react-alert'


// Api Calls
import PaymentAPI from "../../../api/api_calls/PaymentAPI";


function PaymentConfirmation(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [searchParams, setSearchParams] = useSearchParams();
    const session_id = searchParams.get("session_id")
    const [success, setSuccess] = useState(true); // Assume it's successful, it will almost always be.



    useEffect(() => {
        // Retrieve the session. 
        async function retrieveCheckoutSession() {
            const result = await PaymentAPI.retrieveCheckoutSession({ missionId, session_id, navigate });

            if (result.success) {

            } else {
                setSuccess(false);
                alert.show(result.error, { type: 'error' })
            }
        }

        retrieveCheckoutSession();
    }, []);



    // function onMissionNameChange(event) {
    //     setMissionName(event.target.value);
    // }
    // function onMissionDescriptionChange(event) {
    //     setMissionDescription(event.target.value);
    // }

    // function onClickBack() {
    //     navigate(backPage, { state: { missionId: missionId } })
    // }





    return (
        <div className="create-mission-primary-content-container">
            {success ?
                <>
                    <CreateMissionHeaderAndTitleRow title="Project Launched!" subtitle="Success! Your payment method has been verified. Your project is now live. Contact info@despark.io with any issues or questions." hidePrice={true} />
                    <div className="payment-confirmation-text">
                        Questions? <a href="https://desparkwiki.notion.site/researcher-guide" target="_blank" rel="noopener noreferrer" className="white-link">View our researcher guide</a> for more information.
                    </div>
                    <PrimaryButton onClick={() => navigate("/dashboard")} text="Back to Dashboard" />
                </>
                :
                <>
                    <CreateMissionHeaderAndTitleRow title="Project Pending" subtitle="We were unable to confirm your payment. Please click back and try again. If this issue persists, contact info@despark.io" hidePrice={true} />
                    <PrimaryButton onClick={() => navigate("/createmission/" + missionId + "/payment")} text="Back to Payment" />
                </>
            }
        </div>
    )
}

export default PaymentConfirmation;